// Loader dinâmico e idempotente do SDK JS do Facebook — usado só pelo fluxo de
// Embedded Signup da Meta (ES v4). Propositalmente NÃO fica fixo no
// public/index.html: carregar esse script pra todo mundo pesaria o boot do
// painel mesmo pra clientes que nunca usam a API Oficial. Ele só entra em cena
// quando o cliente chega na tela de conexão oficial.
//
// Idempotente: não importa quantas vezes loadFacebookSdk() seja chamada (ex.:
// StrictMode remontando o componente, ou o cliente clicando de novo antes do
// primeiro carregamento terminar) — só UM <script> é injetado e todo mundo
// aguarda a MESMA promise.

export const FB_SDK_SRC = 'https://connect.facebook.net/pt_BR/sdk.js'
export const FB_SDK_VERSION = 'v26.0'
export const FB_SDK_SCRIPT_ID = 'facebook-jssdk'

let loadPromise = null

export function loadFacebookSdk(appId = process.env.REACT_APP_FB_APP_ID) {
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('SDK do Facebook só pode ser carregado no navegador'))
  }

  // SDK já inicializado (ex.: segunda chamada depois que tudo já resolveu)
  if (window.FB) {
    return Promise.resolve(window.FB)
  }

  // já tem um carregamento em andamento — devolve a MESMA promise, não injeta
  // um segundo <script>
  if (loadPromise) {
    return loadPromise
  }

  loadPromise = new Promise((resolve, reject) => {
    const previousFbAsyncInit = window.fbAsyncInit

    // O SDK do Facebook chama window.fbAsyncInit() sozinho assim que termina de
    // carregar e define window.FB antes disso.
    window.fbAsyncInit = function fbAsyncInit() {
      if (typeof previousFbAsyncInit === 'function') {
        previousFbAsyncInit()
      }

      try {
        window.FB.init({
          appId,
          version: FB_SDK_VERSION,
          xfbml: false,
          cookie: true
        })
        resolve(window.FB)
      } catch (error) {
        loadPromise = null
        reject(error)
      }
    }

    const existingScript = document.getElementById(FB_SDK_SCRIPT_ID)
    if (existingScript) {
      // script já injetado por uma chamada anterior — só aguarda o
      // fbAsyncInit acima, sem duplicar a tag
      return
    }

    const script = document.createElement('script')
    script.id = FB_SDK_SCRIPT_ID
    script.src = FB_SDK_SRC
    script.async = true
    script.defer = true
    script.crossOrigin = 'anonymous'
    script.onerror = () => {
      // remove a tag morta ANTES de liberar loadPromise: se ela ficasse no
      // DOM, a próxima chamada cairia no early-return de "script já
      // injetado" (linha abaixo) e ficaria esperando pra sempre um
      // fbAsyncInit que nunca vai disparar (ex.: adblock bloqueando
      // connect.facebook.net) — botão preso em spinner eterno.
      script.remove()
      loadPromise = null
      reject(new Error('Não foi possível carregar o SDK do Facebook'))
    }

    document.body.appendChild(script)
  })

  return loadPromise
}

// Exportado só para os testes resetarem o estado do módulo entre casos —
// não é usado em produção.
export function __resetFacebookSdkLoaderForTests() {
  loadPromise = null
}
